<script setup lang="ts">
import InputText from 'primevue/inputtext'
import Button from '@/components/Button.vue'
import { computed } from 'vue'

const email = ref()

function handleSubmit() {
  // console.log('submitting form')
}

const currentYear = computed(() => new Date().getFullYear())
</script>

<template>
  <Frame class="sec-footer gpt-2 ds:gpt-4 gpb-3 text-white" w="relative max-w-85% ds:max-w-92% mx-auto grid g-2 t:g-2 ds:g-3">

    <template #bglayer>
      <div class="bg-layer" />
      <div class="glass-layer" />
    </template>
    

    <Frame class="row-footer-container" w="grid gc-250px g-1.5 t:g-2 ds:g-3 lt-txs:g-2 ds:g-1 dm:g-2">
      <Frame class="col-brand">
        <div class="sec-branding">
          <img src="/logo.png" alt="Logo" class="h-20">
        </div>
      </Frame>
      <Frame class="col-links one" w="grid g-1.5">
        <div class="sec-title text-[#2f6aaa]">
          AltraCare
        </div>
        <div class="footer-links flex flex-col g-0.75 t:g-1 fs--05!">
          <NuxtLink class="fs--1!" to="/">Home</NuxtLink>
          <NuxtLink class="fs--1!" to="/about-us">About</NuxtLink>
          <NuxtLink class="fs--1!" to="/our-service">Our 360° Service</NuxtLink>
          <NuxtLink class="fs--1!" to="/products">Products</NuxtLink>
          <!-- <NuxtLink class="fs--1!" to="/sds">Product SDS</NuxtLink> -->
          <!-- <NuxtLink class="fs--1!" to="/blog">Blog</NuxtLink> -->
          <NuxtLink class="fs--1!" to="/contact-us">Contact us</NuxtLink>
        </div>
      </Frame>
      <Frame class="col-links two" w="grid g-1.5">
        <div class="sec-title">
          Product Categories
        </div>
        <div class="footer-links flex flex-col g-0.75 t:g-1 fs--05!">
          <NuxtLink class="fs--1!" to="/products/kitchen">Kitchen Products</NuxtLink>
          <NuxtLink class="fs--1!" to="/products/house-keeping">Housekeeping Products</NuxtLink>
          <NuxtLink class="fs--1!" to="/products/laundry">Laundry Products</NuxtLink>
          <NuxtLink class="fs--1!" to="/products/hand-hygiene">Hand Hygiene Products</NuxtLink>
          <NuxtLink class="fs--1!" to="/products/food-service">Food Service Products</NuxtLink>
          <NuxtLink class="fs--1!" to="/products/disinfectant-wipes">Disinfectant Wipes</NuxtLink>
        </div>
      </Frame>
      <Frame class="col-subscribe w-300px" w="grid g-1.5">
        <div class="sec-title">
          Contact Us 
        </div>
        <form v-if="false" @submit.prevent="handleSubmit" class="form-newsletter grid g-1.5">
            <div class="glh-1! fs--05!">Stay updated with our latest features and releases.</div>
            <div class="fields grid g-0.5">
              <div class="field">
                <InputText placeholder="your@email.com" :v-model="email" />
              </div>
              <div class="field">
                <Button btn="blue" class="gpy-0.7 gpx-1 fs--1!">
                  Subscribe
                </Button>
              </div>
            </div>
            <div class="mt-2 text-xs light glh-1! fs--05!">
              By subscribing, you agree to our Privacy Policy and consent to receive updates from our company.
            </div>
          </form>
          <div class="info flex flex-col g-0.5">
            <div class="contact-item flex items-center g-0.5">
              <div class="label font-bold e-light-blue min-w-20px">
                <i class="i i-mdi:email flex items-center w-5 h-5" />
              </div>
              <div class="value"><a href="mailto:info@altracare.com">info@altracarelimited.com</a></div>
            </div>
            <!-- <div class="contact-item flex items-center g-0.5 gmb-1">
              <div class="label font-bold e-light-blue min-w-20px" >
                <i class="i i-mdi:phone flex items-center w-5 h-5" />
              </div>
              <div class="value"><a href="tel:082 333 3333">082 333 3333</a></div>
            </div> -->
            <div class="contact-item flex items-center g-0.5">
              <div class="label font-bold e-light-blue min-w-20px">
                <i class="i i-mdi:instagram flex items-center w-5 h-5" />
              </div>
              <div class="value"><a href="https://www.instagram.com/altracarelimited/" title="Follow us on Instagram" target="_blank">Instagram</a></div>
            </div>
            <!-- <div class="contact-item flex items-center g-0.5">
              <div class="label font-bold e-light-blue min-w-20px">
                <i class="i i-mdi:facebook flex items-center w-5 h-5" />
              </div>
              <div class="value"><a href="https://www.facebook.com/altracare" title="Follow us on Facebook" target="_blank">Facebook</a></div>
            </div> -->
          </div>

      </Frame>

    </Frame>
    <Frame class="row-copyright" w="flex justify-between">
      <Frame class="col-copyright">
        <div class="sec-copy fs--1 glh-1">
          © <strong>{{ currentYear }} <span class="text-blue-500">AltraCare</span></strong> all rights reserved | <a class="website-development-company" href="https://www.mpiredigital.co.za" target="_blank" title="Website development company">MPIRE</a>
        </div>
      </Frame>
      <Frame class="col-links">
        <div class="sec-social flex space-x-2">
          <div class="social">
            <a href="https://www.instagram.com/altracarelimited/" title="Follow us on Instagram" target="_blank">
              <i class="i i-carbon:logo-instagram" />
            </a>
          </div>
          <!-- <div class="social">
            <i class="i i-carbon:logo-twitter" />
          </div>
          <div class="social">
            <i class="i i-carbon:logo-linkedin" />
          </div>
          <div class="social">
            <i class="i i-carbon:logo-youtube" />
          </div> -->
        </div>
      </Frame>
      

    </Frame>
   
  </Frame>
</template>

<style lang="scss" scoped>
.sec-footer {
  /* background: var(--i-dark-blue); */
  background: white;
  position: relative;

  background: radial-gradient(circle, #f1faff, white);



  background-size: cover;

  .glass-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    backdrop-filter: blur(10px);
  }

  .bg-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-image: url('/images/3.jpeg'); */
    background-attachment: fixed;
    opacity: 0.05;
    background-size: cover;
    background-position: center bottom;
  }

  a {
    

    font-size: fs(0);
    transition: all 0.2s ease;

    @include mq($from: t) {
      font-size: fs(-1);
    }

    &:hover {
      color: var(--c-sky-blue);
      text-decoration: none;
    }
  }


  .sec-title {
    text-transform: uppercase;
    color: #05a6ce; /*rgb(58, 99, 143); */
    
    font-weight: 600;
    font-size: fs(0);
    font-family: var(--quicksand);

    @include mq($from: t) {
      font-size: fs(0);
    }
  }

  .footer-links {
    
    a {
      text-transform: uppercase;
      color: var(--i-dark-blue);
      /* color: rgb(121 147 175); */
      font-weight: 500;
      font-size: fs(-0.5);

      @include mq($from: t) {
        font-size: 14px;
      }

      &:hover {
        color: #05a6ce;
      }
    }
  }

  .col-subscribe {
    color: rgb(58, 99, 143);

    font-size: fs(-0.5);

    /* .light { */
    /*   color: var(--blue-100) !important; */
    /* } */

    .form-newsletter {
      div {
        color: rgb(58, 99, 143);
        font-size: fs(0);
        line-height: gr(1.2);

        @include mq($from: t) {
          font-size: fs(-1);
        }
      }

      input {
        padding: gr(0.75) gr(0.75) gr(0.75) gr(1);
        width: 100%;

        background: transparent !important;
        border: none;
        /* border-color: #0d4e99 !important; */
        border-radius: gr(2);
        color: rgb(58, 99, 143) !important;

        border-color: #8bbfc8 !important;


        &::placeholder {
          font-size: fs(-0.5);
          color: #8bbfc8 !important;
        }

      }

      .p-button {
        background: var(--c-sky-blue);
        color: white;
        font-weight: 500;
        font-size: fs(-0.5);

        &:hover {
          background: var(--c-sky-blue);
        }
      }
    }

    .contact-item {
      .label {
        color: var(--i-blue);
        i {
          color: var(--i-blue);
        }
      }

      .value {
        a {
          color: var(--base-650);

          font-size: fs(-0.5);
          transition: all 0.2s ease;

          &:hover {
            color: var(--c-sky-blue);
          }
        }
      }
      
    }
  }

}

.row-copyright {
  font-size: fs(-0.5);
  line-height: gr(1.2);
  
  color: rgb(121 147 175);
  text-transform: uppercase;

  @include mq($from: t) {
    font-size: 13px;
  }

  .website-development-company {
    
    font-size: fs(-15);
    color: rgb(121 147 175);
    text-decoration: none;

    color: #94acc6;

    &:hover {
      color: #a1b8d2;
    }
  }

  .green {
    color:#a5c144;
  }
}
</style>